exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "blockquote{background:#F9F9F9;border-left:10px solid #CCCCCC;margin:1.5em 10px;padding:0.5em 10px;quotes:\"“\" \"”\" \"‘\" \"’\"}blockquote:before{color:#CCCCCC;content:open-quote;font-size:4em;line-height:0.1em;margin-right:0.25em;vertical-align:-0.4em}blockquote p{display:inline}.beliefs{margin-left:4%;margin-right:5%}\n", ""]);

